import { Theme } from '@mui/material/styles';
import { selectClasses } from '@mui/material/Select';
// ----------------------------------------------------------------------

export function select(theme: Theme) {
  return {
    MuiSelect: {
      styleOverrides: {
        icon: {
          right: 10,
          width: 18,
          height: 18,
          top: 'calc(50% - 9px)',
        },
        root: {
          [`&.${selectClasses.disabled}`]: {
            [`& > input,textarea`]: {
              "color": '#343434 !important',
            },
          },
        }
      },
    },
    MuiNativeSelect: {
      styleOverrides: {
        icon: {
          right: 10,
          width: 18,
          height: 18,
          top: 'calc(50% - 9px)',
        },
      },
    },
  };
}
